export const CustomFilters = {
    BackstageSelect: {
        styleOverrides: {
            root: {
                background: '#FAFAFA',
                // The EntityTypePicker wraps this in a Box pb={1} pt={1} (8px top + 8px bottom).
                // Use negative margin to absorb that extra space so TIPO aligns with other pickers.
                margin: '-8px 0',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',

                '& label': {
                    textTransform: 'uppercase',
                    fontSize: 12,
                },
            },
        },
    },
    CatalogReactUserListPicker: {
        styleOverrides: {
            root: {
                backgroundColor: '#FAFAFA',
                border: 'solid 1px #CCC',
            },
        }
    },
    CatalogReactEntityOwnerPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontSize: 12
            },
            root: {
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
    CatalogReactEntityProcessingStatusPickerPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontSize: 12
            },
            root: {
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
    CatalogReactEntityAutocompletePicker: {
        styleOverrides: {
            label: {
                '& span': {
                    textTransform: 'uppercase',
                    fontSize: 12
                }
            },
            root: {
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',

                '& span': {
                    textTransform: 'uppercase',
                    fontSize: 12
                }
            }
        }
    },
    ScaffolderReactTemplateCategoryPicker: {
        styleOverrides: {
            label: {
                textTransform: 'uppercase',
                fontWeight: '700',
                marginBottom: 8,
                fontSize: 12
            },
            root: {
                marginBottom: 16,
                background: '#FAFAFA',
                padding: 8,
                borderRadius: 4,
                border: 'solid 1px #CCC',
            }
        }
    },
}